import User from 'flarum/common/models/User';

// Avatar anime acak (self-host) untuk user tanpa avatar — ganti huruf polos.
const COUNT = 300;

function hashId(s) {
  s = String(s == null ? '0' : s);
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  return h;
}

// URL avatar anime deterministik dari id/username.
export function animeAvatarUrl(seed) {
  const n = (hashId(seed) % COUNT) + 1;
  const p = n < 10 ? '0' + n : '' + n;
  return '/assets/brand/anime/' + p + '.jpg';
}

export default function addAnimeAvatars() {
  const orig = User.prototype.avatarUrl;
  User.prototype.avatarUrl = function () {
    let real = null;
    try {
      real = orig ? orig.call(this) : this.attribute('avatarUrl');
    } catch (_) {
      real = null;
    }
    if (real) return real;
    let seed = null;
    try {
      seed = this.id ? this.id() : null;
    } catch (_) {
      seed = null;
    }
    if (!seed) {
      try {
        seed = this.username ? this.username() : null;
      } catch (_) {
        seed = null;
      }
    }
    return animeAvatarUrl(seed || '0');
  };
}
